/**
 * The group categories, in the order the pickers show them (hand-sorted by
 * how often each is chosen). The `GroupCategory` type derives from this
 * list, and both API schemas validate against it, so adding a category is
 * one line here plus its icon, gradient and locale strings.
 */
export const GROUP_CATEGORIES = [
  'friends',
  'trip',
  'events',
  'family',
  'roommates',
  'couple',
  'work',
  'other',
] as const;
